module.exports = (($) => {
    class Loader {
        static show() {
            $('.loader').show();
        }
        static hide() {
            $('.loader').hide();
        }
    }
    $(document).ajaxStart(function() {
        Loader.show();
    });
    $(document).ajaxStop(function() {
        Loader.hide();
    });
    return Loader
})(jQuery)
